/**
 * Presentation helpers for the column picker: how a column is lettered and how
 * a cell value is shown. Kept apart from the component so the component file
 * exports only a component (React fast refresh) and the helpers stay testable.
 */

/** Spreadsheet-style letter for a zero-based column index: 0 → A, 26 → AA. */
export function columnLetter(index: number): string {
  let n = index + 1;
  let out = '';
  while (n > 0) {
    const r = (n - 1) % 26;
    out = String.fromCharCode(65 + r) + out;
    n = Math.floor((n - 1) / 26);
  }
  return out;
}

/**
 * A cell value as the preview shows it. Typed spreadsheet dates arrive as
 * fixed-UTC wall-clock instants, so the UTC components are the wall-clock the
 * utility wrote; formatting them any other way would shift them by the
 * viewer's time zone.
 */
export function formatSample(value: unknown): string {
  if (value === null || value === undefined) return '';
  if (value instanceof Date) {
    return isNaN(value.getTime()) ? '' : value.toISOString().slice(0, 16).replace('T', ' ');
  }
  const text = String(value).trim();
  return text.length > 28 ? `${text.slice(0, 27)}…` : text;
}
